const config = {
    api: {
        url: "https://api.shoesforeducation.org"
    },
}

export default config;